module.exports = __webpack_public_path__ + "img/england.e06d677d.svg";